import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #36a9e0;
  height: 56px;
  border-radius: 10px;
  /* Essa bordar vai fazer sentido no erro. Pois ela será vermelha */
  border: 0;
  padding: 0 16px;
  color: #ffffff;
  width: 100%;
  font-weight: 500;
  margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#36A9E0')};
  }
`;
